import React from 'react';
import { Box } from '@mui/material';
import type { CampaignDto } from '@shared/services/apiService/apiService';
import CallAnalysisGeneral from './analysis/CallAnalysisGeneral';
import type { CallAnalysisActions } from './analysis/CallAnalysisStructuredOutputSection';

interface CallAnalysisTabProps {
  readOnly?: boolean;
  campaign: CampaignDto;
  onDirtyChange?: (isDirty: boolean) => void;
  onActionsChange?: (actions: CallAnalysisActions | null) => void;
}

const CallAnalysisTab: React.FC<CallAnalysisTabProps> = ({
  campaign,
  readOnly = false,
  onDirtyChange,
  onActionsChange,
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <CallAnalysisGeneral
        campaignId={campaign.id}
        readOnly={readOnly}
        isSquadCampaign={Boolean(campaign.squad)}
        onDirtyChange={onDirtyChange}
        onActionsChange={onActionsChange}
      />
    </Box>
  );
};

export default CallAnalysisTab;
